//*react- recursos
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";

//*install
//npm i react-datepicker

//*archivos
import icono from "./calendar.png";

//css
import "./calendar.css";

//*interfaces
interface PropsFecha {
  fecha: any;
  fechaNombre: any;
  texto: any;
  separar: any;
}

//*componente
export default function GeneraComboFecha(props: PropsFecha) {
  //*constantes y variables
  let fecha = props.fecha;
  let fechaNombre = props.fechaNombre;
  let texto = props.texto; //se usa si ocupamos un texto adicional como una nota o algo así
  let separar = props.separar;

  const [date, setDate] = useState(new Date(fecha));
  const handleChange = (date: any) => setDate(date);

  console.log("combo fecha: ", date, " se asigna a: ", { fechaNombre });

  //*vista
  return (
    <>
      <div>
        
        {separar ? (
          <div style={{ textAlign: "left" }}>
            <span title={texto}>{fechaNombre}</span>
            <br />
            <span className="input-icono marT10">
              <DatePicker
                wrapperClassName="datePicker"
                selected={date}
                onChange={handleChange}
                locale={es}
                dateFormat="dd/MM/yyyy"
              />
              <img src={icono} alt="icono" />
            </span>
          </div>
        ) : (
          <div className="esp">
            <span className="txt"  title={texto}>{fechaNombre}</span>
            <span className="input-icono margen10">
              <DatePicker
                wrapperClassName="datePicker"
                selected={date}
                onChange={handleChange}
                locale={es}
                dateFormat="dd/MM/yyyy"
              />
              <img src={icono} alt="icono" className="" />
            </span>
          </div>
        )}
      </div>
    </>
  );
}
